import React from 'react';
import { SEO } from '../components/SEO';
export function HowItWorksPage() {
  return <>
      <SEO title="Aspect — How It Works" description="Aspect documents completed projects through a governed workflow covering photography, verification, rights, and licensing." data-id="element-475" />
      <div className="space-y-24 md:space-y-32" data-id="element-476">
        {/* Intro */}
        <section className="max-w-2xl" data-id="element-477">
          <h1 className="text-3xl md:text-4xl font-medium leading-tight mb-8 text-aspect-black" data-id="element-478">
            How It Works
          </h1>
          <div className="space-y-6 text-lg text-aspect-black/80 leading-relaxed" data-id="element-479">
            <p data-id="element-480">Aspect replaces ad-hoc coordination with a defined sequence.</p>
            <p data-id="element-481">Each stage must be completed before the next begins.</p>
          </div>
        </section>

        {/* Step 1 */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-482">
          <div className="md:col-span-4" data-id="element-483">
            <span className="text-aspect-gray" data-id="element-484">Step 1 — Project Intake</span>
          </div>
          <div className="md:col-span-8 space-y-6" data-id="element-485">
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-486">
              <p data-id="element-487">
                Completed projects are proposed by architects, owners, or
                internal sourcing.
              </p>
              <p data-id="element-488">Only finished, real-world installations are eligible.</p>
            </div>
          </div>
        </section>

        {/* Step 2 */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-489">
          <div className="md:col-span-4" data-id="element-490">
            <span className="text-aspect-gray" data-id="element-491">Step 2 — Photography</span>
          </div>
          <div className="md:col-span-8 space-y-6" data-id="element-492">
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-493">
              <p data-id="element-494">Photography is commissioned under standardized guidelines.</p>
              <p data-id="element-495">
                Shot lists are aligned in advance. Sensitive areas are excluded.
              </p>
            </div>
          </div>
        </section>

        {/* Step 3 */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-496">
          <div className="md:col-span-4" data-id="element-497">
            <span className="text-aspect-gray" data-id="element-498">Step 3 — Verification</span>
          </div>
          <div className="md:col-span-8 space-y-6" data-id="element-499">
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-500">
              <p data-id="element-501">
                Products and systems shown in images are confirmed against
                available documentation.
              </p>
              <p data-id="element-502">Verification status is recorded explicitly.</p>
            </div>
          </div>
        </section>

        {/* Step 4 */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-503">
          <div className="md:col-span-4" data-id="element-504">
            <span className="text-aspect-gray" data-id="element-505">Step 4 — Rights Clearance</span>
          </div>
          <div className="md:col-span-8 space-y-6" data-id="element-506">
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-507">
              <p data-id="element-508">Owner, architect, and photographer permissions are secured.</p>
              <p data-id="element-509">Usage boundaries are defined before distribution.</p>
            </div>
          </div>
        </section>

        {/* Step 5 */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-510">
          <div className="md:col-span-4" data-id="element-511">
            <span className="text-aspect-gray" data-id="element-512">Step 5 — Library Inclusion</span>
          </div>
          <div className="md:col-span-8 space-y-6" data-id="element-513">
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-514">
              <p data-id="element-515">
                Assets that meet all requirements enter the Aspect Library as
                governed objects, not media files.
              </p>
            </div>
          </div>
        </section>

        {/* Step 6 */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12 pb-12" data-id="element-516">
          <div className="md:col-span-4" data-id="element-517">
            <span className="text-aspect-gray" data-id="element-518">Step 6 — Licensing</span>
          </div>
          <div className="md:col-span-8 space-y-6" data-id="element-519">
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-520">
              <p data-id="element-521">
                Manufacturers license assets with visibility into permitted
                usage, attribution requirements, and audit history.
              </p>
            </div>
          </div>
        </section>
      </div>
    </>;
}